// SPDX-License-Identifier: FSL-1.1-Apache-2.0
/**
 * @module ui
 * @package @geenius/analytics/solidjs
 * @description Defines reusable SolidJS Tailwind utility helpers and component
 * class recipes for the analytics UI variant. These primitives keep component
 * styling consistent across cards, buttons, and class composition.
 */

import { cn } from "./cn";
import { cva } from "./cva";

/**
 * Re-exports the SolidJS Tailwind class composition helper.
 */
export { cn };

/**
 * Tailwind class recipe for analytics card containers.
 */
export const cardVariants = cva(
  "rounded-lg border border-border bg-card text-card-foreground shadow-sm",
  {
    variants: {
      tone: {
        default: "",
        muted: "bg-muted/50",
      },
    },
    defaultVariants: {
      tone: "default",
    },
  },
);

/**
 * Tailwind class recipe for analytics action buttons.
 */
export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground hover:opacity-90",
        secondary:
          "border border-border bg-background text-foreground hover:bg-muted",
        ghost: "bg-transparent text-foreground hover:bg-muted",
      },
      size: {
        sm: "h-8 px-3",
        md: "h-10 px-4",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
);
